import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "../data/projects";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "portfolio", label: "Portfolio" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 500);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled || open
          ? "border-b border-line bg-ink/85 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => {
            setOpen(false);
            if (location.pathname !== "/") navigate("/");
            else window.__lenis?.scrollTo(0, { duration: 1.2 });
          }}
          className="flex items-center"
        >
          <Logo className="h-11 w-auto rounded-md" />
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-cream/70 transition-colors duration-300 hover:text-copper"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-enquire"
            onClick={() => go("contact")}
            className="rounded-full bg-copper px-5 py-2.5 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-ink transition-colors duration-300 hover:bg-copper-hover"
          >
            Enquire
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="text-cream md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="border-t border-line bg-ink/95 px-6 py-6 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left font-display text-2xl font-medium text-cream"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta-enquire"
              onClick={() => go("contact")}
              className="mt-2 w-max rounded-full bg-copper px-6 py-3 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-ink"
            >
              Enquire
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
